// Checks if navigating to the previous month would go before the minimum allowed date.
const isPrevMonthDisabled = (minDate: Date, date: Date): boolean => {
  if (!minDate) return false;

  const JANUARY = 0;
  const DECEMBER = 11;
  const ONE_YEAR = 1;
  const ONE_MONTH = 1;

  const currentMonth: number = date.getMonth();
  const currentYear: number = date.getFullYear();

  // Calculate previous month and year.
  let prevMonth: number;
  let prevYear: number;

  if (currentMonth === JANUARY) {
    // Rolling back from January goes to December of previous year.
    prevMonth = DECEMBER;
    prevYear = currentYear - ONE_YEAR;
  } else {
    // Normal case: just go back one month in same year.
    prevMonth = currentMonth - ONE_MONTH;
    prevYear = currentYear;
  }

  const minMonth: number = minDate.getMonth();
  const minYear: number = minDate.getFullYear();

  // Check if previous month/year is before the minimum allowed date
  const isPrevYearBeforeMin: boolean = prevYear < minYear;
  const isSameYearButPrevMonthBeforeMin: boolean =
    prevYear === minYear && prevMonth < minMonth;

  return isPrevYearBeforeMin || isSameYearButPrevMonthBeforeMin;
};

// Checks if navigating to the next month would go beyond the maximum allowed date.
const isNextMonthDisabled = (maxDate: Date, date: Date): boolean => {
  if (!maxDate) return false;

  const currentMonth: number = date.getMonth();
  const currentYear: number = date.getFullYear();
  const nextMonth: number = currentMonth === 11 ? 0 : currentMonth + 1;
  const nextYear: number = currentMonth === 11 ? currentYear + 1 : currentYear;
  const maxMonth: number = maxDate.getMonth();
  const maxYear: number = maxDate.getFullYear();

  return nextYear > maxYear || (nextYear === maxYear && nextMonth > maxMonth);
};

export { isPrevMonthDisabled, isNextMonthDisabled };
